/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RecipientStatus } from './RecipientStatus';
import {
    RecipientStatusFromJSON,
    RecipientStatusFromJSONTyped,
    RecipientStatusToJSON,
    RecipientStatusToJSONTyped,
} from './RecipientStatus';

/**
 * 
 * @export
 * @interface StaffRequestRecipient
 */
export interface StaffRequestRecipient {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    participant_id: string;
    /**
     * 
     */
    status: RecipientStatus;
    /**
     * 
     */
    next_reminder_at: Date | null;
    /**
     * 
     */
    reminder_count: number;
    /**
     * 
     */
    max_reminders: number;
    /**
     * 
     */
    reminders_paused: boolean;
    /**
     * 
     */
    paused_reason: string | null;
    /**
     * 
     */
    last_sent_at: Date | null;
    /**
     * 
     */
    last_activity_at: Date | null;
    /**
     * 
     */
    escalated: boolean;
}



/**
 * Check if a given object implements the StaffRequestRecipient interface.
 */
export function instanceOfStaffRequestRecipient(value: object): value is StaffRequestRecipient {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('next_reminder_at' in value) || value['next_reminder_at'] === undefined) return false;
    if (!('reminder_count' in value) || value['reminder_count'] === undefined) return false;
    if (!('max_reminders' in value) || value['max_reminders'] === undefined) return false;
    if (!('reminders_paused' in value) || value['reminders_paused'] === undefined) return false;
    if (!('paused_reason' in value) || value['paused_reason'] === undefined) return false;
    if (!('last_sent_at' in value) || value['last_sent_at'] === undefined) return false;
    if (!('last_activity_at' in value) || value['last_activity_at'] === undefined) return false;
    if (!('escalated' in value) || value['escalated'] === undefined) return false;
    return true;
}

export function StaffRequestRecipientFromJSON(json: any): StaffRequestRecipient {
    return StaffRequestRecipientFromJSONTyped(json, false);
}

export function StaffRequestRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRequestRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'participant_id': json['participant_id'],
        'status': RecipientStatusFromJSON(json['status']),
        'next_reminder_at': (json['next_reminder_at'] == null ? null : parseDateTime(json['next_reminder_at'])),
        'reminder_count': json['reminder_count'],
        'max_reminders': json['max_reminders'],
        'reminders_paused': json['reminders_paused'],
        'paused_reason': json['paused_reason'],
        'last_sent_at': (json['last_sent_at'] == null ? null : parseDateTime(json['last_sent_at'])),
        'last_activity_at': (json['last_activity_at'] == null ? null : parseDateTime(json['last_activity_at'])),
        'escalated': json['escalated'],
    };
}

export function StaffRequestRecipientToJSON(json: any): StaffRequestRecipient {
    return StaffRequestRecipientToJSONTyped(json, false);
}

export function StaffRequestRecipientToJSONTyped(value?: StaffRequestRecipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'participant_id': value['participant_id'],
        'status': RecipientStatusToJSON(value['status']),
        'next_reminder_at': value['next_reminder_at'] == null ? value['next_reminder_at'] : serializeDateTime(value['next_reminder_at']),
        'reminder_count': value['reminder_count'],
        'max_reminders': value['max_reminders'],
        'reminders_paused': value['reminders_paused'],
        'paused_reason': value['paused_reason'],
        'last_sent_at': value['last_sent_at'] == null ? value['last_sent_at'] : serializeDateTime(value['last_sent_at']),
        'last_activity_at': value['last_activity_at'] == null ? value['last_activity_at'] : serializeDateTime(value['last_activity_at']),
        'escalated': value['escalated'],
    };
}

